// Initial Redux state for the Data Controls Entity.
//
// READ-ONLY and seeded by DB scripts; the screens are populated
// live from the data-controls-entity GET endpoints. No preseeded fixtures.
export const dataControlEntityInitialState = {
  serviceEntities: [],
  serviceEntitiesLoading: false,

  // The seeded global extension catalogue + native-id resolution map. Read-only,
  // served by the SAME data-controls-entity GET endpoint (a new {resource} value),
  // so there is no new route and no write path at all.
  extensionCatalogue: [],
  extensionCatalogueLoading: false,

  scanRules: [],
  scanRulesLoading: false,

  statusCode: null,
  message: '',
  error: false,
}
